import { render, staticRenderFns } from "./goods-camp.vue?vue&type=template&id=c0c1c81c&scoped=true"
import script from "./goods-camp.vue?vue&type=script&lang=js"
export * from "./goods-camp.vue?vue&type=script&lang=js"
import style0 from "./goods-camp.vue?vue&type=style&index=0&id=c0c1c81c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c1c81c",
  null
  
)

export default component.exports